var CachedMaterialLoader = {
	cache:{},

	load: function(group, texurl, after) {
		var cache = CachedMaterialLoader.cache[group + "-" + texurl];

		if (cache == undefined) {			
			cache = {'new': true};

			var ltex = new THREE.TextureLoader().load(texurl, function(tex) {
				this.cache.texture = tex;
				CachedMaterialLoader.cache[group + "-" + texurl] = this.after(this.cache);
			}.bind({'after': after, 'cache': cache}));

		} else {
			cache.new = false;
			after(cache);
		}
	}
}